<h1 mat-dialog-title>Errore</h1>
<div>{{data.msg}}</div>
<button mat-button mat-dialog-close>Chiudi</button>